import React, { useRef } from 'react';
import { isOddUnderMinValue, useOddData } from './OddWrapper';
import { useHighlightOddChange } from './useHighlightOddChange';

export default function MenuMatchItemOdd(props) {
    const oddContainer = useRef(null);
    
    useHighlightOddChange(oddContainer, props.value, props.matchData.isLive);
    
    const [desc, selected, addBet] = useOddData(props);
    
    let classes = '';
    if (selected) {
        classes += 'selezionata';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }
    
    return (
        <>
            <div ref={oddContainer} className={"quota-widget-evento quota bordo-tondo d-flex justify-content-between " + classes} onClick={addBet} > 
                <span>{desc}</span>
                {props.value == null  || isOddUnderMinValue(props.rawValue) ?
                    <i className="fa fa-lock"></i>
                    :
                    <span>{props.value}</span>
                }
            </div>
        </>
    );
}
